import { atom } from 'recoil';

export const MobileShowSearchBarState = atom({
    key: 'MobileShowSearchBarState', 
    default: true, 
});